export default __webpack_public_path__ + "static/media/trincheta.473803a1.png";